import styled, { css } from 'styled-components';
import { size } from '../../layout/helpers';

export interface IText {
  $size?: 'xsmall' | 'small' | 'standard' | 'large' | 'xlarge';
  $tone?:
    | 'main'
    | 'alt'
    | 'primary'
    | 'link'
    | 'facebook'
    | 'success'
    | 'warning'
    | 'error'
    | 'info';
  $align?: 'left' | 'center' | 'right';
  $weight?: 'regular' | 'medium' | 'bold';
  $lineHeight?: 'main' | 'alt';
  $decoration?: 'line-through';
  $noWrap?: boolean;
}

export const Text = styled.div.attrs({})<IText>`
  &:is(h1, h2, h3, h4, h5, h6) {
    margin: 0;
  }

  ${({ $size }) =>
    $size === 'xsmall'
      ? css`
          font-size: ${(props) => props.theme.font.size.xsmall};
        `
      : $size === 'small'
        ? css`
            font-size: ${(props) => props.theme.font.size.small};
          `
        : $size === 'standard'
          ? css`
              font-size: ${(props) => props.theme.font.size.regular};
            `
          : $size === 'large'
            ? css`
                font-size: ${(props) => props.theme.font.size.large};
              `
            : $size === 'xlarge'
              ? css`
                font-size: ${(props) => props.theme.font.size.xlarge};
              `
              : undefined}

  ${({ $tone }) =>
    $tone === 'main'
      ? css`
          color: var(--c-text-main);
        `
      : $tone === 'alt'
        ? css`
            color: var(--c-text-muted);
          `
        : $tone === 'primary'
          ? css`
              color: var(--c-primary-bg);
            `
          : $tone === 'link'
            ? css`
                color: var(--c-link);
              `
            : $tone === 'facebook'
              ? css`
                  color: var(--c-facebook-blue);
                `
              : $tone === 'success'
                ? css`
                    color: var(--c-semantic-success-500);
                  `
                : $tone === 'warning'
                  ? css`
                      color: var(--c-semantic-warning-500);
                    `
                  : $tone === 'error'
                    ? css`
                        color: var(--c-semantic-error-500);
                      `
                    : $tone === 'info'
                      ? css`
                        color: var(--c-semantic-info-500);
                      `
                      : undefined}

  ${({ $align }) =>
    $align === 'left'
      ? css`
          text-align: left;
        `
      : $align === 'center'
        ? css`
            text-align: center;
          `
        : $align === 'right'
          ? css`
              text-align: right;
            `
          : undefined}

  ${({ $weight }) =>
    $weight === 'regular'
      ? css`
          font-weight: var(--font-weight-regular);
        `
      : $weight === 'medium'
        ? css`
            font-weight: var(--font-weight-medium);
          `
        : $weight === 'bold'
          ? css`
            font-weight: var(--font-weight-bold);
          `
          : undefined}

${({ $lineHeight }) =>
  $lineHeight === 'main'
    ? css`
          line-height: ${(props) => props.theme.font.lineHeight.main};
        `
    : $lineHeight === 'alt'
      ? css`
            line-height: ${(props) => props.theme.font.lineHeight.alt};
          `
      : undefined}

  ${({ $decoration }) =>
    $decoration === 'line-through'
      ? css`
          text-decoration: line-through;
        `
      : undefined}

${({ $noWrap }) =>
  $noWrap &&
  css`
          white-space: nowrap;
        `}

  // Custom styling on user mentions
  .user-mention {
    border-radius: ${size(0.5)};
    padding: ${size(0.25)} ${size(0.5)};
    user-select: all;
    background-color: var(--c-secondary-bg);
    color: var(--c-secondary-fg);
    cursor: default;
  }
`;
